// CÓDIGO COMPLETO E CORRIGIDO PARA: src/pages/AgenteDashboard.js

import React, { useState, useEffect } from 'react';
import { firestore } from '../firebase/config';
import { collection, query, where, getDocs } from 'firebase/firestore';
import Navbar from '../components/Navbar';
import './Form.css';
// AJUSTE 1: Importar a função para adicionar à fila offline
import { adicionarVisitaNaFila, getVisitasNaFila } from '../db';
// Hook para buscar localidades dinâmicas do Firestore
import { useLocalidades } from '../hooks/useLocalidades';

// --- Mapas para exibição das visitas do dia ---
const visitaStatusDisplayMap = { 'INSPECIONADO': 'Trabalhado', 'RECUPERADO': 'Recuperado', 'RECUSA': 'Recusa', 'FECHADO': 'Fechado' };
const tipoImovelDisplayMap = { 'R': 'Residência', 'C': 'Comércio', 'TB': 'Terreno baldio', 'O': 'Outros', 'PE': 'Ponto estratégico' };

// --- Componente de Resumo do Cabeçalho ---
function HeaderSummary({ data }) {
  const atividadeMap = { '1': '1 - RA', '2': '2 - LI+T', '3': '3 - PE', '4': '4 - T', '5': '5 - DF', '6': '6 - PVE', '7': '7 - ID', '8': '8 - BT' };
  const zonaMap = { '1': 'Urbana', '2': 'Rural' };

  return (
    <div className="summary-box">
      <strong>Município:</strong> {data.municipio} | <strong>Localidade:</strong> {data.localidade} | <strong>Ciclo/Ano:</strong> {data.cicloAno} | <strong>Zona:</strong> {zonaMap[data.zona]} | <strong>Atividade:</strong> {atividadeMap[data.atividade]}
    </div>
  );
}

// --- Componente de Revisão (VERSÃO COMPLETA E CORRIGIDA) ---
function ReviewModal({ headerData, visitaData, onEdit, onConfirm, loading }) {
  // Mapas para traduzir os códigos em texto legível
  const atividadeMap = { '1': 'RA', '2': 'LI+T', '3': 'PE', '4': 'T', '5': 'DF', '6': 'PVE', '7': 'ID', '8': 'BT' };
  const zonaMap = { '1': 'Urbana', '2': 'Rural' };
  const concluidaMap = { 'N': 'Não', 'S': 'Sim' };
  const visitaStatusMap = { 'INSPECIONADO': 'Trabalhado', 'RECUPERADO': 'Recuperado', 'RECUSA': 'Recusa', 'FECHADO': 'Fechado' };
  const tipoImovelMap = { 'R': 'Residência', 'C': 'Comércio', 'TB': 'Terreno baldio', 'O': 'Outros', 'PE': 'Ponto estratégico' };

  return (
    <div className="modal-overlay">
      <div className="modal-content review-modal">
        <h3>Revisão da Visita</h3>

        <div className="review-section">
          <h4>Cabeçalho da Atividade</h4>
          <p><strong>Município:</strong> {headerData.municipio}</p>
          <p><strong>Localidade:</strong> {headerData.localidade} | <strong>Categoria:</strong> {headerData.categLocalidade || 'N/A'}</p>
          <p><strong>Ciclo/Ano:</strong> {headerData.cicloAno || 'N/A'}</p>
          <p><strong>Nº Controle Foco:</strong> {headerData.nControleFoco || 'N/A'} | <strong>Nº Sinan:</strong> {headerData.nSinan || 'N/A'}</p>
          <p><strong>Zona:</strong> {zonaMap[headerData.zona] || 'N/A'} | <strong>Concluída?:</strong> {concluidaMap[headerData.concluida] || 'N/A'}</p>
          <p><strong>Atividade:</strong> {atividadeMap[headerData.atividade] || 'N/A'}{headerData.atividade === '2' && headerData.subAtividadeLIT && (
            ` (${headerData.subAtividadeLIT.li ? 'LI' : ''}${headerData.subAtividadeLIT.li && headerData.subAtividadeLIT.t ? '+' : ''}${headerData.subAtividadeLIT.t ? 'T' : ''})`
          )}</p>
        </div>

        <div className="review-section">
          <h4>Detalhes da Inspeção do Imóvel</h4>
          <p><strong>Quarteirão:</strong> {visitaData.quarteirao} | <strong>Sequência do Dia:</strong> {visitaData.sequencia}</p>
          <p><strong>Logradouro:</strong> {visitaData.logradouro}, Nº {visitaData.numeroImovel}</p>
          <p><strong>Complemento:</strong> {visitaData.complemento || 'Nenhum'}</p>
          <p><strong>Hora de Entrada:</strong> {visitaData.horaEntrada || 'Não informada'}</p>
          <p><strong>Status:</strong> {visitaStatusMap[visitaData.visitaStatus]}</p>
          <p><strong>Tipo de Imóvel:</strong> {tipoImovelMap[visitaData.tipoImovel]}</p>
        </div>

        <div className="review-section">
          <h4>Nº de Depósitos</h4>
          <p><strong>Inspec.:</strong> A1({visitaData.depA1 || 0}), A2({visitaData.depA2 || 0}), B({visitaData.depB || 0}), C({visitaData.depC || 0}), D1({visitaData.depD1 || 0}), D2({visitaData.depD2 || 0}), E({visitaData.depE || 0})</p>
          <p><strong>Eliminados:</strong> {visitaData.depositoEliminado || 0}</p>
        </div>

        <div className="review-section">
          <h4>Animais no Domicílio</h4>
          <p><strong>Possui cães ou gatos?:</strong> {visitaData.temAnimais === 'SIM' ? 'Sim' : 'Não'}</p>
          {visitaData.temAnimais === 'SIM' && visitaData.animais?.length > 0 && (
            visitaData.animais.map((animal, index) => (
              <p key={index} style={{ marginLeft: '1rem' }}>
                - {animal.tipo} ({animal.sexo}): <strong>{animal.quantidade}</strong>
              </p>
            ))
          )}
        </div>

        <div className="review-section">
          <h4>Coleta de Amostra</h4>
          <p><strong>Coleta realizada?:</strong> {visitaData.coletaAmostra ? 'Sim' : 'Não'}</p>

          {/* A MÁGICA ACONTECE AQUI:
              Se a coleta foi 'Sim' e existe uma lista de amostras,
              nós fazemos um loop (.map) para mostrar cada uma. */}
          {visitaData.coletaAmostra && visitaData.amostras?.length > 0 && (
            visitaData.amostras.map((amostra, index) => (
              <p key={index} style={{ marginLeft: '1rem', borderTop: '1px solid #eee', paddingTop: '8px' }}>
                <strong>Amostra {index + 1}:</strong><br />
                - Depósito: {amostra.depositoColeta || 'N/I'}<br />
                - Nota Obs: {amostra.notaInicial || 'N/I'}
              </p>
            ))
          )}
        </div>

        <div className="review-section">
          <h4>Tratamento</h4>

          {/* --- Seção Focal (Larvicida) --- */}
          <p><strong>Focal (Larvicida):</strong> {visitaData.tratFocalImovelTratado ? 'Sim' : 'Não'}</p>
          {/* Se o checkbox foi marcado E a lista não está vazia, mostra os detalhes */}
          {visitaData.tratFocalImovelTratado && visitaData.tratamentosFocais?.length > 0 && (
            visitaData.tratamentosFocais.map((trat, index) => (
              <p key={index} style={{ marginLeft: '1rem' }}>
                - Dep. {trat.depositoTratado}: {trat.qtdeGramas}g de {trat.tipoLarvicida || 'N/I'}
              </p>
            ))
          )}

          {/* --- Seção Perifocal (Adulticida) --- */}
          <p style={{ marginTop: '10px' }}>
            <strong>Perifocal (Adulticida):</strong> {visitaData.tratPerifocalImovelTratado ? 'Sim' : 'Não'}
          </p>
          {/* Se o checkbox foi marcado E a lista não está vazia, mostra os detalhes */}
          {visitaData.tratPerifocalImovelTratado && visitaData.tratamentosPerifocais?.length > 0 && (
            visitaData.tratamentosPerifocais.map((trat, index) => (
              <p key={index} style={{ marginLeft: '1rem' }}>
                - Tratamento {index + 1}: {trat.qtdeGramas}g de {trat.tipoAdulticida || 'N/I'}
              </p>
            ))
          )}
        </div>

        <div className="modal-actions">
          <button type="button" onClick={onEdit} disabled={loading}>Editar</button>
          <button type="button" onClick={onConfirm} disabled={loading}>{loading ? 'Salvando...' : 'Confirmar e Salvar'}</button>
        </div>
      </div>
    </div>
  );
}

// --- Componente de Cabeçalho do Dia ---
function CabecalhoDiario({ headerData, setHeaderData, setHeaderSubmitted, ciclo, setCiclo, localidadesDisponiveis }) {
  const handleChange = (e) => {
    const { name, value } = e.target;

    if (name === 'localidade') {
      // Busca categoria e zona a partir dos dados do Firestore
      const localDoc = (localidadesDisponiveis || []).find(l => l.nome === value);
      const categoria = localDoc ? localDoc.categoria : '';
      const zona = localDoc ? localDoc.zona : '';
      setHeaderData(prev => ({
        ...prev,
        localidade: value,
        categLocalidade: categoria,
        zona: zona
      }));
    } else {
      setHeaderData(prev => ({ ...prev, [name]: value }));
    }
  };
  const handleSubAtividadeChange = (e) => {
    const { name, checked } = e.target;
    setHeaderData(prev => {
      const currentSub = prev.subAtividadeLIT || {};
      return {
        ...prev,
        subAtividadeLIT: { ...currentSub, [name]: checked }
      };
    });
  };
  // Localidades agora vêm do Firestore via prop (não mais hardcoded)
  return (
    <fieldset>
      <legend>Cabeçalho da Atividade do Dia</legend>

      {/* DOCUMENTAÇÃO: 
            O container principal "form-grid header-grid" agora envolve TODOS os campos.
            Isso cria um único contexto de grid, garantindo que todos os itens se alinhem corretamente.
        */}
      <div className="form-grid header-grid">

        {/* --- Linha 1 --- */}
        <div className="input-group">
          <label>Município</label>
          <input name="municipio" value={headerData.municipio} readOnly />
        </div>
        <div className="input-group">
          <label>Localidade *</label>
          <select name="localidade" value={headerData.localidade} onChange={handleChange} required>
            <option value="">Selecione uma localidade...</option>
            {(localidadesDisponiveis || []).map(local => (
              <option key={local.id} value={local.nome}>
                {local.nome}
              </option>
            ))}
          </select>
        </div>
        <div className="input-group">
          <label>Categ. Localidade</label>
          <input name="categLocalidade" value={headerData.categLocalidade} readOnly />
        </div>

        {/* --- Linha 2 --- */}
        <div className="input-group">
          <label>Ciclo *</label>
          <select
            name="ciclo"
            value={ciclo}
            onChange={e => setCiclo(e.target.value)}
            required
          >
            <option value="">Selecione</option>
            {[1, 2, 3, 4, 5, 6].map(c => <option key={c} value={c}>{c}</option>)}
          </select>
        </div>
        <div className="input-group">
          <label>Nº Controle Foco</label>
          <input name="nControleFoco" value={headerData.nControleFoco} onChange={handleChange} />
        </div>
        <div className="input-group">
          <label>Nº Sinan</label>
          <input name="nSinan" value={headerData.nSinan} onChange={handleChange} />
        </div>

        {/* --- Linha 3 --- */}
        <div className="input-group">
          <label>Zona</label>
          <select name="zona" value={headerData.zona} onChange={handleChange} required>
            <option value="">Selecione a zona...</option>
            <option value="1">Urbana</option>
            <option value="2">Rural</option>
          </select>
        </div>
        <div className="input-group">
          <label>Atividade *</label>
          <select name="atividade" value={headerData.atividade} onChange={handleChange} required>
            <option value="">Selecione a atividade...</option>
            <option value="1">1 - RA</option>
            <option value="2">2 - LI+T</option>
            <option value="3">3 - PE</option>
            <option value="4">4 - T</option>
            <option value="5">5 - DF</option>
            <option value="6">6 - PVE</option>
            <option value="7">7 - ID</option>
            <option value="8">8 - BT</option>
          </select>
        </div>
        <div className="input-group">
          <label>Concluída?</label>
          <select name="concluida" value={headerData.concluida} onChange={handleChange} required>
            <option value="">Selecione...</option>
            <option value="S">Sim</option>
            <option value="N">Não</option>
          </select>
        </div>

        {/* --- Linha 4 (Apenas para LI+T) --- */}
        {headerData.atividade === '2' && (
          <div className="input-group grid-col-span-full">
            <label>Sub-Atividade LI+T</label>
            <div className="checkbox-options">
              <label>
                <input
                  type="checkbox"
                  name="li"
                  checked={headerData.subAtividadeLIT?.li || false}
                  onChange={handleSubAtividadeChange}
                /> LI (Levantamento de Índice)
              </label>
              <label>
                <input
                  type="checkbox"
                  name="t"
                  checked={headerData.subAtividadeLIT?.t || false}
                  onChange={handleSubAtividadeChange}
                /> T (Tratamento)
              </label>
            </div>
          </div>
        )}
      </div>

      <div className="form-actions">
        <button
          type="button"
          onClick={() => {
            if (!headerData.localidade || !ciclo || !headerData.zona || !headerData.atividade || !headerData.concluida) {
              alert("Preencha todos os campos obrigatórios!");
            } else {
              setHeaderSubmitted(true);
            }
          }}
          className="header-button"
        >
          Iniciar Registros
        </button>
      </div>
    </fieldset>
  );
}

// --- Função Auxiliar para Hora Atual (HH:MM:SS) ---
const getHoraAtual = () => {
  const now = new Date();
  const hours = String(now.getHours()).padStart(2, '0');
  const minutes = String(now.getMinutes()).padStart(2, '0');
  const seconds = String(now.getSeconds()).padStart(2, '0');
  return `${hours}:${minutes}:${seconds}`;
};

// --- Função Auxiliar para Normalização ---
const normalizarTexto = (texto) => {
  if (!texto) return '';
  return String(texto).trim().toUpperCase();
};

// --- Componente Principal do Agente ---
function AgenteDashboard({ user }) {
  // Estados para o cabeçalho
  const initialHeaderState = {
    municipio: 'Eunápolis',
    localidade: '',
    categLocalidade: '',
    zona: '',
    atividade: '',
    concluida: 'N',
    nControleFoco: '',
    nSinan: '',
    subAtividadeLIT: null
  };
  const [headerData, setHeaderData] = useState(initialHeaderState);
  const [headerSubmitted, setHeaderSubmitted] = useState(false);
  const [ciclo, setCiclo] = useState('');

  // Estados para a visita
  const initialVisitaState = {
    quarteirao: '',
    logradouro: '',
    numeroImovel: '',
    complemento: '',
    // AJUSTE: Pré-preenchimento com a hora atual
    horaEntrada: getHoraAtual(),
    visitaStatus: 'INSPECIONADO',
    tipoImovel: 'R',
    temAnimais: '',
    animais: [],
    depA1: 0, depA2: 0, depB: 0, depC: 0, depD1: 0, depD2: 0, depE: 0,
    depositoEliminado: 0,
    coletaAmostra: false,
    amostras: [],
    tratFocalImovelTratado: false,     // O checkbox "mestre" para Focal
    tratamentosFocais: [],             // A lista de tratamentos focais
    tratPerifocalImovelTratado: false, // O checkbox "mestre" para Perifocal
    tratamentosPerifocais: [],         // A lista de tratamentos perifocais
  };
  const [visitaData, setVisitaData] = useState(initialVisitaState);
  const [isReviewing, setIsReviewing] = useState(false);
  const [loading, setLoading] = useState(false);
  const [message] = useState('');
  const [visitasHoje, setVisitasHoje] = useState(0); // Contador de visitas salvas no dia
  const [ultimaVisita, setUltimaVisita] = useState(null); // Estado para armazenar a última visita
  const [visitasPendentesSync, setVisitasPendentesSync] = useState(0); // Contador de visitas na fila offline
  const [visitasDoDia, setVisitasDoDia] = useState([]); // Lista completa de visitas do dia
  const [showVisitasDoDia, setShowVisitasDoDia] = useState(false); // Toggle para mostrar a lista
  const [visitaDetalhe, setVisitaDetalhe] = useState(null); // Visita selecionada para ver detalhes
  const [isOnline, setIsOnline] = useState(navigator.onLine); // Status de conectividade
  const [syncingForce, setSyncingForce] = useState(false); // Loading do botão de força-sync

  // Localidades dinâmicas do Firestore
  const { localidades: localidadesDisponiveis } = useLocalidades();

  // Função para buscar visitas do dia (Online + Offline)
  // Função para buscar visitas do dia (Online + Offline) - REFATORADA
  const fetchVisitasDoDia = async () => {
    if (!user) return;

    const startOfDay = new Date();
    startOfDay.setHours(0, 0, 0, 0);

    let docsOnline = [];
    let docsOffline = [];

    // 1. Tenta buscar Online
    try {
      const q = query(collection(firestore, 'relatoriosDiarios_FAD1'), where('idAgente', '==', user.uid), where('dataAtividade', '>=', startOfDay));
      const querySnapshot = await getDocs(q);
      docsOnline = querySnapshot.docs.map(d => d.data());
    } catch (error) {
      console.warn("Offline ou erro ao buscar no Firestore:", error);
      // Se der erro (ex: sem internet), docsOnline continua vazio []
    }

    // 2. Busca Offline (Sempre)
    try {
      const fila = await getVisitasNaFila();
      
      // Atualiza o contador de pendências globais para o alerta
      const pendentesGeral = fila.filter(item => item.idAgente === user.uid);
      setVisitasPendentesSync(pendentesGeral.length);

      docsOffline = fila.filter(item => {
        // Garante que é do agente atual e de hoje
        const dataItem = new Date(item.dataAtividade);
        return item.idAgente === user.uid && dataItem >= startOfDay;
      });
    } catch (error) {
      console.error("Erro ao buscar fila offline:", error);
    }

    // 3. Unifica as listas
    let todasVisitas = [...docsOnline, ...docsOffline];

    // 4. Ordena por data (Mais recente primeiro)
    todasVisitas.sort((a, b) => {
      // Normaliza a data: Firestore usa Timestamp (seconds), JS usa Date ou string ISO
      const dateA = a.dataAtividade?.seconds ? new Date(a.dataAtividade.seconds * 1000) : new Date(a.dataAtividade);
      const dateB = b.dataAtividade?.seconds ? new Date(b.dataAtividade.seconds * 1000) : new Date(b.dataAtividade);
      return dateB - dateA; // Decrescente
    });

    // 4.1 Filtra Visitas Canceladas (ROBUSTO)
    todasVisitas = todasVisitas.filter(v => !v.statusRegistro || v.statusRegistro.trim().toLowerCase() === 'ativo');

    // 5. Atualiza os estados
    setVisitasHoje(todasVisitas.length);
    setVisitasDoDia(todasVisitas);

    if (todasVisitas.length > 0) {
      setUltimaVisita(todasVisitas[0]);
    } else {
      setUltimaVisita(null);
    }
  };

  // Efeito inicial
  useEffect(() => {
    fetchVisitasDoDia();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [user]);

  // Monitora conectividade
  useEffect(() => {
    const handleOnline = () => setIsOnline(true);
    const handleOffline = () => setIsOnline(false);
    window.addEventListener('online', handleOnline);
    window.addEventListener('offline', handleOffline);
    return () => {
      window.removeEventListener('online', handleOnline);
      window.removeEventListener('offline', handleOffline);
    };
  }, []);

  // Função para forçar sincronização manualmente
  const handleForceSync = async () => {
    setSyncingForce(true);
    try {
      // Tenta via Background Sync API
      const registration = await navigator.serviceWorker.ready;
      await registration.sync.register('sync-visitas');
    } catch (e) {
      // Fallback: mensagem direta ao Service Worker
      if (navigator.serviceWorker.controller) {
        navigator.serviceWorker.controller.postMessage('SYNC_NOW');
      }
    }
    // Aguarda 3 segundos e atualiza o contador
    setTimeout(async () => {
      await fetchVisitasDoDia();
      setSyncingForce(false);
    }, 3000);
  };

  // Efeito para checar fila offline periodicamente (sincronização em background)
  useEffect(() => {
    const checarFila = async () => {
      if (!user) return;
      try {
        const fila = await getVisitasNaFila();
        const pendentes = fila.filter(item => item.idAgente === user.uid);
        setVisitasPendentesSync(pendentes.length);
      } catch (error) {
        console.error("Erro ao checar fila de sincronização:", error);
      }
    };
    
    // Checa a cada 10 segundos para ver se o service worker já sincronizou e esvaziou a fila
    const interval = setInterval(checarFila, 10000); 
    return () => clearInterval(interval);
  }, [user]);

  useEffect(() => {
    // Se o status da visita for 'recusa' ou 'fechado', limpa os dados dos animais.
    if (visitaData.visitaStatus === 'RECUSA' || visitaData.visitaStatus === 'FECHADO') {
      // Verifica se os dados já estão limpos para evitar re-renderizações desnecessárias
      if (visitaData.temAnimais !== '' || visitaData.animais.length > 0) {
        setVisitaData(prev => ({
          ...prev,
          temAnimais: '', // Limpa a seleção "Sim/Não"
          animais: []      // Limpa a lista de animais cadastrados
        }));
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [visitaData.visitaStatus]); // Roda sempre que o status da visita mudar

  // Efeito para preencher categoria/zona da localidade a partir dos dados do Firestore
  useEffect(() => {
    if (headerData.localidade && localidadesDisponiveis.length > 0) {
      const localDoc = localidadesDisponiveis.find(l => l.nome === headerData.localidade);
      if (localDoc) {
        setHeaderData(prevData => ({
          ...prevData,
          categLocalidade: localDoc.categoria || "",
          zona: prevData.zona || localDoc.zona || ""
        }));
      }
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [headerData.localidade, localidadesDisponiveis]);

  // Função para resetar o formulário de visita
  const resetFormVisita = () => {
    // AJUSTE: Ao resetar, a hora de entrada deve ser atualizada para o momento do reset
    setVisitaData({ ...initialVisitaState, horaEntrada: getHoraAtual() });
  };

  // Handler genérico para campos de visita
  const handleVisitaChange = (e) => {
    const { name, value, type, checked } = e.target;

    // Lista dos campos que são <select> e NÃO devem ser convertidos para maiúsculas
    const selectFields = ['visitaStatus', 'tipoImovel', 'temAnimais'];

    let finalValue;

    if (type === 'checkbox') {
      finalValue = checked;
    } else if (selectFields.includes(name)) {
      // Se for um <select> da lista, usa o valor original (ex: 'inspecionado', 'R', 'sim')
      finalValue = value;
    } else {
      // Para todos os outros campos (inputs de texto), converte para maiúsculas
      finalValue = String(value).toUpperCase();
    }

    // Atualiza o estado com o valor final correto
    setVisitaData(prev => ({ ...prev, [name]: finalValue }));
  };

  // Handler para animais
  const handleAnimalChange = (index, e) => {
    const { name, value } = e.target;
    const novosAnimais = [...visitaData.animais];
    novosAnimais[index][name] = value;
    setVisitaData(prev => ({ ...prev, animais: novosAnimais }));
  };

  // Adiciona um novo animal
  const adicionarAnimal = () => {
    setVisitaData(prev => ({
      ...prev,
      animais: [
        ...prev.animais,
        { tipo: 'CAO', sexo: 'MACHO', quantidade: 1 }
      ]
    }));
  };

  // Remove um animal
  const removerAnimal = (indexToRemove) => {
    setVisitaData(prev => ({
      ...prev,
      animais: prev.animais.filter((_, index) => index !== indexToRemove)
    }));
  };

  // --- Funções para Tratamento FOCAL (Larvicida) ---
  const adicionarTratamentoFocal = () => {
    setVisitaData(prev => ({
      ...prev,
      tratamentosFocais: [
        ...(prev.tratamentosFocais || []),
        { depositoTratado: 'A1', tipoLarvicida: '', qtdeGramas: '' }
      ]
    }));
  };
  const removerTratamentoFocal = (indexToRemove) => {
    setVisitaData(prev => ({
      ...prev,
      tratamentosFocais: prev.tratamentosFocais.filter((_, index) => index !== indexToRemove)
    }));
  };
  const handleTratamentoFocalChange = (index, event) => {
    const { name, value } = event.target;
    const novosTratamentos = [...visitaData.tratamentosFocais];
    const finalValue = (name === 'qtdeGramas') ? value : String(value).toUpperCase();
    novosTratamentos[index][name] = finalValue;
    setVisitaData(prev => ({ ...prev, tratamentosFocais: novosTratamentos }));
  };

  // --- Funções para Tratamento PERIFOCAL (Adulticida) ---
  const adicionarTratamentoPerifocal = () => {
    setVisitaData(prev => ({
      ...prev,
      tratamentosPerifocais: [
        ...(prev.tratamentosPerifocais || []),
        { tipoAdulticida: '', qtdeGramas: '' }
      ]
    }));
  };
  const removerTratamentoPerifocal = (indexToRemove) => {
    setVisitaData(prev => ({
      ...prev,
      tratamentosPerifocais: prev.tratamentosPerifocais.filter((_, index) => index !== indexToRemove)
    }));
  };
  const handleTratamentoPerifocalChange = (index, event) => {
    const { name, value } = event.target;
    const novosTratamentos = [...visitaData.tratamentosPerifocais];
    const finalValue = (name === 'qtdeGramas') ? value : String(value).toUpperCase();
    novosTratamentos[index][name] = finalValue;
    setVisitaData(prev => ({ ...prev, tratamentosPerifocais: novosTratamentos }));
  };

  // Handler para ir para a tela de revisão
  const handleGoToReview = (e) => {
    e.preventDefault();

    // LÓGICA DE LIMPEZA AUTOMÁTICA (Auto-Cleanup)
    // Se o usuário zerou um depósito, removemos automaticamente as amostras vinculadas a ele.
    let amostrasLimpas = visitaData.amostras;
    if (visitaData.coletaAmostra && visitaData.amostras.length > 0) {
      amostrasLimpas = visitaData.amostras.filter(amostra => {
        const tipo = amostra.depositoColeta;
        const chaveDep = `dep${tipo}`;
        const qtd = Number(visitaData[chaveDep]) || 0;
        // Mantém apenas se a quantidade do depósito for maior que 0
        return qtd > 0;
      });

      // Se houve remoção, atualizamos o estado e avisamos o usuário (feedback visual importante)
      if (amostrasLimpas.length !== visitaData.amostras.length) {
        const removidas = visitaData.amostras.length - amostrasLimpas.length;
        alert(`${removidas} amostra(s) foram removidas automaticamente pois os depósitos correspondentes foram alterados para 0.`);

        // Atualiza o estado com a lista limpa
        setVisitaData(prev => ({ ...prev, amostras: amostrasLimpas }));
        // Interrompe aqui para o usuário revisar as amostras restantes antes de prosseguir
        return;
      }
    }

    // ▼▼▼ VALIDAÇÕES OBRIGATÓRIAS DE DETALHAMENTO ▼▼▼

    // 1. Animais: se marcou SIM, deve ter pelo menos 1 animal cadastrado
    if (visitaData.temAnimais === 'SIM' && visitaData.animais.length === 0) {
      alert('⚠️ Você informou que há animais no domicílio.\nPor favor, adicione pelo menos um registro de animal (cão ou gato) antes de continuar.');
      return;
    }

    // 2. Coleta de amostra: se marcou SIM (checkbox), deve ter pelo menos 1 tubito adicionado
    if (visitaData.coletaAmostra && amostrasLimpas.length === 0) {
      alert('⚠️ Você marcou que realizou coleta de amostra.\nPor favor, adicione pelo menos um tubito antes de continuar.');
      return;
    }

    // 3. Tratamento Focal: se marcou SIM (checkbox), deve ter pelo menos 1 tratamento adicionado
    if (visitaData.tratFocalImovelTratado && (visitaData.tratamentosFocais || []).length === 0) {
      alert('⚠️ Você marcou que o imóvel foi tratado com Larvicida (Focal).\nPor favor, adicione pelo menos um registro de tratamento focal antes de continuar.');
      return;
    }

    // 4. Tratamento Perifocal: se marcou SIM (checkbox), deve ter pelo menos 1 tratamento adicionado
    if (visitaData.tratPerifocalImovelTratado && (visitaData.tratamentosPerifocais || []).length === 0) {
      alert('⚠️ Você marcou que o imóvel foi tratado com Adulticida (Perifocal).\nPor favor, adicione pelo menos um registro de tratamento perifocal antes de continuar.');
      return;
    }

    // ▲▲▲ FIM DAS VALIDAÇÕES ▲▲▲

    setIsReviewing(true);
  };

  // Adiciona uma nova amostra (tubito) - AJUSTE: Seleção inteligente do depósito padrão
  const adicionarAmostra = () => {
    // Identifica qual o primeiro depósito que possui quantidade > 0
    // Isso evita que o padrão seja 'A1' quando só existe 'A2', por exemplo.
    const tipos = ['A1', 'A2', 'B', 'C', 'D1', 'D2', 'E'];
    const mapping = {
      'A1': visitaData.depA1,
      'A2': visitaData.depA2,
      'B': visitaData.depB,
      'C': visitaData.depC,
      'D1': visitaData.depD1,
      'D2': visitaData.depD2,
      'E': visitaData.depE
    };

    // Encontra o primeiro tipo que tem (Number(valor) > 0)
    const primeiroValido = tipos.find(t => Number(mapping[t]) > 0) || 'A1';

    setVisitaData(prev => ({
      ...prev,
      amostras: [
        ...(prev.amostras || []),
        {
          depositoColeta: primeiroValido, // Usa o encontrado ou 'A1' como fallback
          notaInicial: '',
          analise: { status: 'PENDENTE' }
        }
      ]
    }));
  };

  // Remove uma linha da lista de amostras pelo seu índice
  const removerAmostra = (indexToRemove) => {
    setVisitaData(prev => ({
      ...prev,
      amostras: prev.amostras.filter((_, index) => index !== indexToRemove)
    }));
  };

  // Atualiza os dados de uma amostra específica na lista
  const handleAmostraChange = (index, event) => {
    const { name, value } = event.target;
    const novasAmostras = [...visitaData.amostras];
    novasAmostras[index][name] = value;
    setVisitaData(prev => ({ ...prev, amostras: novasAmostras }));
  };

  // AJUSTE 2: A função `handleConfirmAndSave` corrigida para usar a hora de entrada
  const handleConfirmAndSave = async () => {
    setLoading(true);

    // ▼▼▼ BLOCO DE VALIDAÇÃO E CONSTRUÇÃO DO CICLO/ANO ▼▼▼
    if (!ciclo) {
      alert("Por favor, selecione um ciclo antes de salvar.");
      setLoading(false); // Libera o botão
      setIsReviewing(false); // Volta para a tela de edição
      return;
    }
    const anoAtual = new Date().getFullYear();
    const cicloAnoFinal = `${ciclo}/${anoAtual}`;
    // ▲▲▲ FIM DO BLOCO ADICIONADO ▲▲▲

    try {
      // --- Etapa 1: Obter Coordenadas de GPS (sem alterações) ---
      // A localização é capturada AQUI, no momento do salvamento (fim da visita)
      const getCoordsPromise = new Promise((resolve) => {
        if (!navigator.geolocation) { return resolve(null); }
        // Otimização para rua (Offline/Bateria): Aceita GPS de até 2 mins atrás, e espera até 15s pra achar satélite
        const options = { enableHighAccuracy: true, timeout: 15000, maximumAge: 120000 };
        navigator.geolocation.getCurrentPosition(
          (position) => resolve({
            latitude: position.coords.latitude,
            longitude: position.coords.longitude,
            precisao_metros: position.coords.accuracy
          }),
          () => resolve(null),
          options
        );
      });

      const coordenadas = await getCoordsPromise;

      if (coordenadas === null) {
        if (!window.confirm("Não foi possível obter GPS. Deseja salvar mesmo sem as coordenadas?")) {
          setLoading(false);
          return;
        }
      }

      // ▼▼▼ AJUSTE PRINCIPAL PARA DATA E HORA ▼▼▼
      let dataDaVisita;
      if (visitaData.horaEntrada) {
        const hoje = new Date();
        const partesHora = visitaData.horaEntrada.split(':');
        const horas = partesHora[0];
        const minutos = partesHora[1];
        const segundos = partesHora.length > 2 ? partesHora[2] : 0;
        // Define a hora e os minutos e segundos do dia de hoje com base no campo 'horaEntrada'
        hoje.setHours(horas, minutos, segundos, 0);
        dataDaVisita = hoje;
      } else {
        // Se a hora de entrada não for fornecida, usa a data/hora atual como fallback
        dataDaVisita = new Date();
      }
      // ▲▲▲ FIM DO AJUSTE ▲▲▲

      let dadosDaVisitaCorrigidos = { ...visitaData };

      // 2. Se o usuário marcou "Não" para animais, nós limpamos a lista.
      if (dadosDaVisitaCorrigidos.temAnimais === 'NAO') {
        dadosDaVisitaCorrigidos.animais = [];
      }

      const dadosParaSalvar = {
        ...headerData,
        localidade: normalizarTexto(headerData.localidade), // GARANTE CAPITALIZAÇÃO
        ...visitaData,
        cicloAno: cicloAnoFinal, // Adiciona o valor construído
        sequencia: visitasHoje + 1,
        depositos: { A1: Number(visitaData.depA1) || 0, A2: Number(visitaData.depA2) || 0, B: Number(visitaData.depB) || 0, C: Number(visitaData.depC) || 0, D1: Number(visitaData.depD1) || 0, D2: Number(visitaData.depD2) || 0, E: Number(visitaData.depE) || 0 },
        coordenadas: coordenadas,
        idAgente: user.uid,
        emailAgente: user.email,
        dataAtividade: dataDaVisita, // <--- AQUI USAMOS A DATA CORRIGIDA
        status: visitaData.coletaAmostra ? 'Aguardando Análise' : 'Finalizado',
        analiseLaboratorio: null,
      };
      const { depA1, depA2, depB, depC, depD1, depD2, depE, ...finalReport } = dadosParaSalvar;

      // --- Etapa 2: Salvar na Fila Local ---
      await adicionarVisitaNaFila(finalReport);
      console.log("Salvo na fila local com sucesso.");

      // --- Etapa 3: Atualizar a Interface do Usuário IMEDIATAMENTE ---
      // setVisitasHoje(prevCount => prevCount + 1); // REMOVIDO: Agora usamos fetchVisitasDoDia
      // await fetchVisitasDoDia(); // <--- ATUALIZA O CARD DE ÚLTIMA VISITA

      // OTIMIZAÇÃO: Atualiza o estado localmente para economizar leituras no Firebase
      setVisitasHoje(prev => prev + 1);
      setUltimaVisita(dadosParaSalvar);
      setVisitasPendentesSync(prev => prev + 1);

      // Mensagem de sucesso ajustada para refletir a realidade
      alert('Visita salva no dispositivo! A sincronização será tentada em segundo plano.');

      resetFormVisita();
      setIsReviewing(false);
      // setHeaderData(initialHeaderState); // MELHORIA UX: Mantém os dados do cabeçalho (Localidade, etc) preenchidos
      setHeaderSubmitted(false); // VOLTA PARA O CABEÇALHO PARA NOVAS DEFINIÇÕES SE NECESSÁRIO


      // (Opcional) Scroll para o topo
      window.scrollTo(0, 0);

    } catch (error) {
      // Este bloco 'catch' agora só será acionado se a gravação no IndexedDB falhar, o que é raro.
      console.error('Falha CRÍTICA ao salvar na fila local:', error);
      alert('ERRO: Não foi possível salvar a visita no dispositivo.');
      setLoading(false);
      return; // Interrompe a execução em caso de falha grave
    }

    // --- Etapa 4: Tentar Agendar a Sincronização (fora do bloco try/catch principal) ---
    // Fazemos isso depois que o usuário já recebeu a confirmação de sucesso.
    try {
      const registration = await navigator.serviceWorker.ready;
      await registration.sync.register('sync-visitas');
    } catch (syncError) {
      // Fallback: Se o Background Sync falhar (ex: browser não suporta ou desabilitado),
      // enviamos uma mensagem direta para o Service Worker tentar sincronizar agora.
      if (navigator.serviceWorker.controller) {
        navigator.serviceWorker.controller.postMessage('SYNC_NOW');
      }
    } finally {
      setLoading(false);
    }
  };


  return (
    <div>
      <Navbar user={user} />
      
      {visitasPendentesSync > 0 && (
        <div style={{
          backgroundColor: '#ff9800',
          color: '#fff',
          padding: '10px 16px',
          textAlign: 'center',
          fontWeight: 'bold',
          boxShadow: '0 2px 4px rgba(0,0,0,0.15)',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          gap: '12px',
          flexWrap: 'wrap'
        }}>
          <span>⚠️ Você possui {visitasPendentesSync} visita(s) salva(s) offline.</span>
          {isOnline ? (
            <button
              onClick={handleForceSync}
              disabled={syncingForce}
              style={{
                backgroundColor: '#fff',
                color: '#e65100',
                border: '2px solid #e65100',
                borderRadius: '6px',
                padding: '4px 14px',
                fontWeight: 'bold',
                cursor: syncingForce ? 'not-allowed' : 'pointer',
                fontSize: '0.85em',
                opacity: syncingForce ? 0.7 : 1
              }}
            >
              {syncingForce ? '⏳ Sincronizando...' : '🔄 Forçar Sincronização'}
            </button>
          ) : (
            <span style={{ fontSize: '0.85em', opacity: 0.85 }}>📵 Sem internet. Aguarde conexão.</span>
          )}
        </div>
      )}

      {/* --- LISTA DE VISITAS DO DIA (View-Only, do cache local) --- */}
      {visitasDoDia.length > 0 && (
        <div style={{
          margin: '10px',
          border: '1px solid #e0e0e0',
          borderRadius: '8px',
          overflow: 'hidden',
          boxShadow: '0 1px 3px rgba(0,0,0,0.08)'
        }}>
          <button
            onClick={() => setShowVisitasDoDia(prev => !prev)}
            style={{
              width: '100%',
              padding: '10px 14px',
              backgroundColor: '#1565c0',
              color: '#fff',
              border: 'none',
              textAlign: 'left',
              cursor: 'pointer',
              fontWeight: 'bold',
              fontSize: '0.95em',
              display: 'flex',
              justifyContent: 'space-between',
              alignItems: 'center'
            }}
          >
            <span>📋 Minhas Visitas de Hoje ({visitasDoDia.length})</span>
            <span>{showVisitasDoDia ? '▲ Recolher' : '▼ Ver lista'}</span>
          </button>

          {showVisitasDoDia && (
            <div style={{ padding: '10px', backgroundColor: '#fafafa' }}>
              <p style={{ fontSize: '0.8em', color: '#888', margin: '0 0 8px' }}>
                🔒 Somente leitura — Dados do armazenamento local do dispositivo. Disponível apenas no dia atual.
              </p>
              <div style={{ overflowX: 'auto' }}>
                <table style={{ width: '100%', borderCollapse: 'collapse', fontSize: '0.85em' }}>
                  <thead>
                    <tr style={{ backgroundColor: '#e3f2fd', textAlign: 'left' }}>
                      <th style={{ padding: '7px 10px', borderBottom: '1px solid #ccc' }}>Seq.</th>
                      <th style={{ padding: '7px 10px', borderBottom: '1px solid #ccc' }}>Hora</th>
                      <th style={{ padding: '7px 10px', borderBottom: '1px solid #ccc' }}>Quarteirão</th>
                      <th style={{ padding: '7px 10px', borderBottom: '1px solid #ccc' }}>Logradouro</th>
                      <th style={{ padding: '7px 10px', borderBottom: '1px solid #ccc' }}>Nº Imóvel</th>
                      <th style={{ padding: '7px 10px', borderBottom: '1px solid #ccc' }}>Tipo</th>
                      <th style={{ padding: '7px 10px', borderBottom: '1px solid #ccc' }}>Status</th>
                      <th style={{ padding: '7px 10px', borderBottom: '1px solid #ccc' }}>Sync</th>
                      <th style={{ padding: '7px 10px', borderBottom: '1px solid #ccc' }}>Detalhe</th>
                    </tr>
                  </thead>
                  <tbody>
                    {visitasDoDia.map((v, idx) => {
                      const isPendente = !v.idVisita; // visitas sem idVisita ainda estão na fila local
                      return (
                        <tr key={idx} style={{ borderBottom: '1px solid #f0f0f0', backgroundColor: idx % 2 === 0 ? '#fff' : '#f9f9f9' }}>
                          <td style={{ padding: '6px 10px' }}>{v.sequencia || idx + 1}</td>
                          <td style={{ padding: '6px 10px' }}>{v.horaEntrada || '—'}</td>
                          <td style={{ padding: '6px 10px' }}>{v.quarteirao || '—'}</td>
                          <td style={{ padding: '6px 10px' }}>{v.logradouro || '—'}</td>
                          <td style={{ padding: '6px 10px' }}>{v.numeroImovel || '—'}</td>
                          <td style={{ padding: '6px 10px' }}>{tipoImovelDisplayMap[v.tipoImovel] || v.tipoImovel}</td>
                          <td style={{ padding: '6px 10px' }}>{visitaStatusDisplayMap[v.visitaStatus] || v.visitaStatus}</td>
                          <td style={{ padding: '6px 10px' }}>
                            <span style={{
                              padding: '2px 7px',
                              borderRadius: '10px',
                              fontSize: '0.8em',
                              fontWeight: 'bold',
                              backgroundColor: isPendente ? '#fff3e0' : '#e8f5e9',
                              color: isPendente ? '#e65100' : '#2e7d32'
                            }}>
                              {isPendente ? '⏳ Pendente' : '✅ Sincronizado'}
                            </span>
                          </td>
                          <td style={{ padding: '6px 10px' }}>
                            <button
                              onClick={() => setVisitaDetalhe(visitaDetalhe === idx ? null : idx)}
                              style={{
                                padding: '3px 10px',
                                fontSize: '0.8em',
                                backgroundColor: '#1565c0',
                                color: '#fff',
                                border: 'none',
                                borderRadius: '4px',
                                cursor: 'pointer'
                              }}
                            >
                              {visitaDetalhe === idx ? 'Fechar' : 'Ver'}
                            </button>
                          </td>
                        </tr>
                      );
                    })}
                  </tbody>
                </table>
              </div>

              {/* Painel de detalhes inline */}
              {visitaDetalhe !== null && visitasDoDia[visitaDetalhe] && (() => {
                const v = visitasDoDia[visitaDetalhe];
                return (
                  <div style={{
                    marginTop: '10px',
                    padding: '12px',
                    backgroundColor: '#e8eaf6',
                    borderRadius: '8px',
                    border: '1px solid #9fa8da',
                    fontSize: '0.88em'
                  }}>
                    <strong>🔍 Detalhes da Visita #{visitaDetalhe + 1}</strong>
                    <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '4px 16px', marginTop: '8px' }}>
                      <p><strong>Localidade:</strong> {v.localidade || '—'}</p>
                      <p><strong>Ciclo/Ano:</strong> {v.cicloAno || '—'}</p>
                      <p><strong>Logradouro:</strong> {v.logradouro}, Nº {v.numeroImovel} {v.complemento ? `(${v.complemento})` : ''}</p>
                      <p><strong>Quarteirão:</strong> {v.quarteirao || '—'}</p>
                      <p><strong>Hora Entrada:</strong> {v.horaEntrada || '—'}</p>
                      <p><strong>Status Visita:</strong> {visitaStatusDisplayMap[v.visitaStatus] || v.visitaStatus}</p>
                      <p><strong>Tipo Imóvel:</strong> {tipoImovelDisplayMap[v.tipoImovel] || v.tipoImovel}</p>
                      <p><strong>Dep. A1:</strong> {v.depositos?.A1 ?? v.depA1 ?? 0} | <strong>A2:</strong> {v.depositos?.A2 ?? v.depA2 ?? 0} | <strong>B:</strong> {v.depositos?.B ?? v.depB ?? 0} | <strong>C:</strong> {v.depositos?.C ?? v.depC ?? 0}</p>
                      <p><strong>Dep. D1:</strong> {v.depositos?.D1 ?? v.depD1 ?? 0} | <strong>D2:</strong> {v.depositos?.D2 ?? v.depD2 ?? 0} | <strong>E:</strong> {v.depositos?.E ?? v.depE ?? 0} | <strong>Elim.:</strong> {v.depositoEliminado ?? 0}</p>
                      <p><strong>Coleta Amostra:</strong> {v.coletaAmostra ? 'Sim' : 'Não'}</p>
                      <p><strong>Animais:</strong> {v.temAnimais === 'SIM' ? 'Sim' : 'Não'}</p>
                      <p><strong>Trat. Focal:</strong> {v.tratFocalImovelTratado ? 'Sim' : 'Não'}</p>
                      <p><strong>Trat. Perifocal:</strong> {v.tratPerifocalImovelTratado ? 'Sim' : 'Não'}</p>
                    </div>
                    {v.coordenadas && (
                      <p style={{ marginTop: '4px' }}><strong>GPS:</strong> {v.coordenadas.latitude?.toFixed(6)}, {v.coordenadas.longitude?.toFixed(6)} (±{v.coordenadas.precisao_metros?.toFixed(0)}m)</p>
                    )}
                  </div>
                );
              })()}
            </div>
          )}
        </div>
      )}

      <div className="form-container">
        {!headerSubmitted ? (
          <>
            {/* --- CARD DE ÚLTIMA VISITA (Movido para cá) --- */}
            {ultimaVisita && (
              <div style={{
                backgroundColor: '#e3f2fd',
                border: '1px solid #90caf9',
                borderRadius: '8px',
                padding: '10px 15px',
                marginBottom: '15px',
                color: '#0d47a1',
                fontSize: '0.9em'
              }}>
                <strong>📍 Última visita registrada:</strong><br />
                {ultimaVisita.logradouro}, Nº {ultimaVisita.numeroImovel} {ultimaVisita.complemento ? `(${ultimaVisita.complemento})` : ''}
                <br />
                <span style={{ fontSize: '0.85em', color: '#555' }}>
                  Horário: {ultimaVisita.horaEntrada || 'N/I'} | Quarteirão: {ultimaVisita.quarteirao}
                </span>
              </div>
            )}
            <CabecalhoDiario headerData={headerData} setHeaderData={setHeaderData} setHeaderSubmitted={setHeaderSubmitted} ciclo={ciclo} setCiclo={setCiclo} localidadesDisponiveis={localidadesDisponiveis} />
          </>
        ) : !isReviewing ? (
          <>
            <HeaderSummary data={headerData} />
            {message && <p className="message">{message}</p>}
            <form onSubmit={handleGoToReview}>
              {/* O seu JSX do formulário continua aqui, sem alterações */}

              <fieldset><legend>Detalhes da Inspeção</legend><div className="form-grid"><div className="input-group"><label>Nº Sequência do Dia</label><input value={visitasHoje + 1} readOnly /></div><div className="input-group"><label>Nº do quarteirão</label><input name="quarteirao" type="number" value={visitaData.quarteirao} onChange={handleVisitaChange} required /></div><div className="input-group grid-col-span-2"><label>Nome do Logradouro</label><input name="logradouro" type="text" value={visitaData.logradouro} onChange={handleVisitaChange} required /></div><div className="input-group"><label>Nº do Imóvel (Funasa)</label><input name="numeroImovel" type="text" value={visitaData.numeroImovel} onChange={handleVisitaChange} required /></div><div className="input-group"><label>Complemento</label><input name="complemento" type="text" value={visitaData.complemento} onChange={handleVisitaChange} /></div><div className="input-group"><label>Hora de Entrada</label><input name="horaEntrada" type="time" step="1" value={visitaData.horaEntrada} onChange={handleVisitaChange} /></div><div className="input-group"><label>Status da Visita</label><select name="visitaStatus" value={visitaData.visitaStatus} onChange={handleVisitaChange}><option value="INSPECIONADO">Trabalhado</option><option value="RECUPERADO">Recuperado</option><option value="RECUSA">Recusa</option><option value="FECHADO">Fechado</option></select></div><div className="input-group"><label>Tipo de Imóvel</label><select name="tipoImovel" value={visitaData.tipoImovel} onChange={handleVisitaChange}><option value="R">Residência</option><option value="C">Comércio</option><option value="TB">Terreno baldio</option><option value="O">Outros</option><option value="PE">Ponto estratégico</option></select></div></div></fieldset>
              <fieldset>
                <legend>Animais no Domicílio</legend>
                <div className="input-group">
                  <label>Possui cães ou gatos?</label>
                  <select
                    name="temAnimais"
                    value={visitaData.temAnimais}
                    onChange={handleVisitaChange}

                    // TORNA OBRIGATÓRIO apenas se o status for 'inspecionado' ou 'recuperado'
                    required={visitaData.visitaStatus === 'INSPECIONADO' || visitaData.visitaStatus === 'RECUPERADO'}

                    // DESABILITA o campo se o status for 'recusa' ou 'fechado'
                    disabled={visitaData.visitaStatus === 'RECUSA' || visitaData.visitaStatus === 'FECHADO'}
                  >
                    <option value="">Selecione</option>
                    <option value="SIM">Sim</option>
                    <option value="NAO">Não</option>
                  </select>
                </div>

                {/* Este bloco só aparece se a resposta for "Sim" */}
                {visitaData.temAnimais === 'SIM' && (
                  <div className="animal-section">
                    {visitaData.animais.map((animal, index) => (
                      <div key={index} className="form-grid animal-row">
                        <div className="input-group">
                          <label>Tipo</label>
                          <select name="tipo" value={animal.tipo} onChange={(e) => handleAnimalChange(index, e)}>
                            <option value="CAO">Cão</option>
                            <option value="GATO">Gato</option>
                          </select>
                        </div>
                        <div className="input-group">
                          <label>Sexo</label>
                          <select name="sexo" value={animal.sexo} onChange={(e) => handleAnimalChange(index, e)}>
                            <option value="MACHO">Macho</option>
                            <option value="FEMEA">Fêmea</option>
                          </select>
                        </div>
                        <div className="input-group">
                          <label>Quantidade</label>
                          <input name="quantidade" type="number" min="1" value={animal.quantidade} onChange={(e) => handleAnimalChange(index, e)} />
                        </div>
                        <button type="button" className="remove-btn" onClick={() => removerAnimal(index)}>Remover</button>
                      </div>
                    ))}
                    <button type="button" className="add-btn" onClick={adicionarAnimal}>
                      + Adicionar outro grupo de animais
                    </button>
                  </div>
                )}
              </fieldset>
              <fieldset><legend>Nº de Depósitos</legend><div className="form-grid deposits"><div className="input-group"><label>A1</label><input name="depA1" type="number" value={visitaData.depA1} onChange={handleVisitaChange} /></div><div className="input-group"><label>A2</label><input name="depA2" type="number" value={visitaData.depA2} onChange={handleVisitaChange} /></div><div className="input-group"><label>B</label><input name="depB" type="number" value={visitaData.depB} onChange={handleVisitaChange} /></div><div className="input-group"><label>C</label><input name="depC" type="number" value={visitaData.depC} onChange={handleVisitaChange} /></div><div className="input-group"><label>D1</label><input name="depD1" type="number" value={visitaData.depD1} onChange={handleVisitaChange} /></div><div className="input-group"><label>D2</label><input name="depD2" type="number" value={visitaData.depD2} onChange={handleVisitaChange} /></div><div className="input-group"><label>E</label><input name="depE" type="number" value={visitaData.depE} onChange={handleVisitaChange} /></div><div className="input-group"><label>Eliminados</label><input name="depositoEliminado" type="number" value={visitaData.depositoEliminado} onChange={handleVisitaChange} /></div></div></fieldset>
              <fieldset>
                <legend>Coleta de Amostra (Tubitos)</legend>
                <div className="form-grid">
                  <div className="checkbox-group grid-col-span-full">
                    <label>
                      <input name="coletaAmostra" type="checkbox" checked={visitaData.coletaAmostra} onChange={handleVisitaChange} /> Coleta amostra?
                    </label>
                  </div>
                </div>

                {visitaData.coletaAmostra && (
                  <div className="sample-section">
                    {visitaData.amostras.map((amostra, index) => (
                      <div key={index} className="form-grid sample-row">
                        <div className="input-group">
                          <label>Depósito</label>
                          <select name="depositoColeta" value={amostra.depositoColeta} onChange={(e) => handleAmostraChange(index, e)}>
                            {visitaData.depA1 > 0 && <option value="A1">A1</option>}
                            {visitaData.depA2 > 0 && <option value="A2">A2</option>}
                            {visitaData.depB > 0 && <option value="B">B</option>}
                            {visitaData.depC > 0 && <option value="C">C</option>}
                            {visitaData.depD1 > 0 && <option value="D1">D1</option>}
                            {visitaData.depD2 > 0 && <option value="D2">D2</option>}
                            {visitaData.depE > 0 && <option value="E">E</option>}
                          </select>
                        </div>
                        <div className="input-group">
                          <label>Observação</label>
                          <input name="notaInicial" type="text" value={amostra.notaInicial} onChange={(e) => handleAmostraChange(index, e)} placeholder="Ex: Tubo 01" />
                        </div>
                        <button type="button" className="remove-btn" onClick={() => removerAmostra(index)}>Remover Tubito</button>
                      </div>
                    ))}
                    <button type="button" className="add-btn" onClick={adicionarAmostra}>
                      + Adicionar Tubito
                    </button>
                  </div>
                )}
              </fieldset>
              <fieldset>
                <legend>Tratamento</legend>
                <div className="form-grid">

                  {/* --- Tratamento Focal --- */}
                  <div className="checkbox-group grid-col-span-full">
                    <label>
                      <input
                        name="tratFocalImovelTratado"
                        type="checkbox"
                        checked={visitaData.tratFocalImovelTratado}
                        onChange={handleVisitaChange}
                      /> Imóvel tratado com Larvicida (Focal)?
                    </label>
                  </div>

                  {/* Só mostra a lista de tratamentos FOCAIS se o checkbox acima estiver marcado */}
                  {visitaData.tratFocalImovelTratado && (
                    <div className="sample-section grid-col-span-full">
                      {visitaData.tratamentosFocais.map((tratamento, index) => (
                        <div key={index} className="form-grid sample-row">
                          <div className="input-group"><label>Depósito Tratado</label><select name="depositoTratado" value={tratamento.depositoTratado} onChange={(e) => handleTratamentoFocalChange(index, e)}><option value="A1">A1</option><option value="A2">A2</option><option value="B">B</option><option value="C">C</option><option value="D1">D1</option><option value="D2">D2</option><option value="E">E</option></select></div>
                          <div className="input-group"><label>Tipo de Larvicida</label><input name="tipoLarvicida" type="text" value={tratamento.tipoLarvicida} onChange={(e) => handleTratamentoFocalChange(index, e)} placeholder="Ex: TEMEFÓS" required /></div>
                          <div className="input-group"><label>Qtde. (gramas)</label><input name="qtdeGramas" type="number" step="0.1" min={0.1} value={tratamento.qtdeGramas} onChange={(e) => handleTratamentoFocalChange(index, e)} required /></div>
                          <button type="button" className="remove-btn" onClick={() => removerTratamentoFocal(index)}>Remover</button>
                        </div>
                      ))}
                      <button type="button" className="add-btn" onClick={adicionarTratamentoFocal}>+ Adicionar Tratamento Focal</button>
                    </div>
                  )}

                  {/* --- Tratamento Perifocal --- */}
                  <div className="checkbox-group grid-col-span-full">
                    <label>
                      <input
                        name="tratPerifocalImovelTratado"
                        type="checkbox"
                        checked={visitaData.tratPerifocalImovelTratado}
                        onChange={handleVisitaChange}
                      /> Imóvel tratado com Adulticida (Perifocal)?
                    </label>
                  </div>

                  {/* Só mostra a lista de tratamentos PERIFOCAIS se o checkbox acima estiver marcado */}
                  {visitaData.tratPerifocalImovelTratado && (
                    <div className="sample-section grid-col-span-full">
                      {visitaData.tratamentosPerifocais.map((tratamento, index) => (
                        <div key={index} className="form-grid sample-row">
                          <div className="input-group"><label>Tipo de Adulticida</label><input name="tipoAdulticida" type="text" value={tratamento.tipoAdulticida} onChange={(e) => handleTratamentoPerifocalChange(index, e)} placeholder="Ex: MALATHION" required /></div>
                          <div className="input-group"><label>Qtde. (gramas)</label><input name="qtdeGramas" type="number" step="0.1" min={0.1} value={tratamento.qtdeGramas} onChange={(e) => handleTratamentoPerifocalChange(index, e)} required /></div>
                          <button type="button" className="remove-btn" onClick={() => removerTratamentoPerifocal(index)}>Remover</button>
                        </div>
                      ))}
                      <button type="button" className="add-btn" onClick={adicionarTratamentoPerifocal}>+ Adicionar Tratamento Perifocal</button>
                    </div>
                  )}
                </div>
              </fieldset>
              <div className="form-actions"><button type="button" className="secondary-button" onClick={() => setHeaderSubmitted(false)}>Alterar Cabeçalho</button><button type="submit">Revisar Dados</button></div>
            </form>
          </>
        ) : (
          <ReviewModal
            headerData={{ ...headerData, cicloAno: `${ciclo}/${new Date().getFullYear()}` }}
            visitaData={{ ...visitaData, sequencia: visitasHoje + 1 }}
            onEdit={() => setIsReviewing(false)}
            onConfirm={handleConfirmAndSave}
            loading={loading}
          />)
        }
      </div >
    </div >

  );
}

export default AgenteDashboard;
